import React from 'react';
import '../../../Statics/Scss/Pages/yaSosSuscriptor.scss';
import Text from '../../Common/common/src/text/Text';

const HeaderSuscription = () => {
    return (
        <div className="textLegendSuscription">
            <Text className="--font-bold --sueca --mb-8">Ya sos suscriptor digital</Text>
            <Text className="--font-bold --arial">Seguí disfrutando de LA NACION sin límites.</Text>
            <Text className="--font-regular --arial --mb-16">Podés gestionar tu suscripción y mejorar tu plan, ingresando a Mi Cuenta.</Text>
        </div>
    );
};

export default HeaderSuscription;
